import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { startOfDayInMilliseconds } from '@utils/date';
import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	startRentDate: number | null;
	endRentDate: number | null;
}

const initialState: IInitialState = {
	...defaultMeta,
	searchValue: '',
	sortDirection: false,
	sortFieldName: null,
	startRentDate: null,
	endRentDate: null,
};

const assetProfileIncomingRequests = createSlice({
	name: 'assetProfileIncomingRequests',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setStartRentDate: (
			state,
			action: PayloadAction<{ startRentDate: number | null }>,
		) => {
			if (action.payload.startRentDate) {
				state.startRentDate = startOfDayInMilliseconds(action.payload.startRentDate);
			} else {
				state.startRentDate = null;
			}

			state.page = initialState.page;
		},
		setEndRentDate: (
			state,
			action: PayloadAction<{ endRentDate: number | null }>,
		) => {
			if (action.payload.endRentDate) {
				state.endRentDate = startOfDayInMilliseconds(action.payload.endRentDate);
			} else {
				state.endRentDate = null;
			}

			state.page = initialState.page;
		},
		resetAssetProfileOutgoingRequestsTable: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSearchValue,
	setSort,
	setStartRentDate,
	setEndRentDate,
} = assetProfileIncomingRequests.actions;

export default assetProfileIncomingRequests.reducer;
